import { TThunkAction } from '../../types/redux';
import { EStatus } from '../../types/likes';
import { setQuestionsReactionAction } from './actions';
import {
  ISetQuestionReactionWebResponse,
  ISetQuestionReactionWebResponse200,
  ISetQuestionReactionWebResponse400,
  fetchSetQuestionReactionWeb,
} from '../../repositories/newbuilding-reviews/v1/set-question-reaction-web';
import { EType } from '../../repositories/newbuilding-reviews/entities/set_question_reaction/SetQuestionReactionRequestSchema';
import { mapLabelFromState, trackReactionAnalyticClick } from '../reviews/analytics/reactionAnalytic';
import { getObjectRating } from '../../selectors/objectInfo';
import { getQuestionById } from '../../selectors/questions';

interface IParams {
  questionId: string;
  type: EStatus;
}

export function setQuestionReaction({ questionId, type }: IParams): TThunkAction<Promise<boolean>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    try {
      const siteType = context.custom.deviceType;
      const state = getState();
      const rating = getObjectRating(state);
      const { like } = getQuestionById(questionId)(state);

      const { response } = await fetchSetQuestionReactionWeb<
        ISetQuestionReactionWebResponse200,
        ISetQuestionReactionWebResponse400
      >({
        httpApi,
        parameters: { questionId, type: type as unknown as EType },
      });

      const label = mapLabelFromState({
        currentState: like.status,
        nextState: (response as ISetQuestionReactionWebResponse).type as unknown as EStatus,
      });
      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType,
        extra: {
          rating,
          question_id: questionId,
          type: 'question',
        },
      };
      trackReactionAnalyticClick({ label, page });

      dispatch(
        setQuestionsReactionAction({
          questionId,
          type: (response as ISetQuestionReactionWebResponse).type as unknown as EStatus,
        }),
      );

      return true;
    } catch (error) {
      logger.error(error, {
        domain: 'question#setQuestionReaction',
        message: error.message,
      });

      return false;
    }
  };
}
